import { render, staticRenderFns } from "./ContactCustomAttributes.vue?vue&type=template&id=ef9dc9a8&scoped=true&"
import script from "./ContactCustomAttributes.vue?vue&type=script&lang=js&"
export * from "./ContactCustomAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ContactCustomAttributes.vue?vue&type=style&index=0&id=ef9dc9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9dc9a8",
  null
  
)

export default component.exports